export const MEDIA_MESSAGES = ({
  GENERIC_LOAD_FAILURE: 'Failed to load media.',
  SIGNED_URL_REFRESH_NOT_SUPPORTED: 'Failed to load media, please pause task and retry.',
  REFRESHING_URL_MESSAGE: 'Reloading media, please wait.',
  DECODING_FRAME_MESSAGE: 'Decoding frame...',
  DEFAULT_LOADING_MESSAGE: 'Loading...',
  REFRESH_AFTER_TIMEOUT_MESSAGE_HEADING: (timeSeconds: number) => {
    return `Refreshing the tool to keep your session secure in ${timeSeconds} secs`;
  },
  REFRESH_AFTER_TIMEOUT_MESSAGE_SUB_HEADING: "Don't worry, Your work won't be lost. Hang tight for a quick refresh, then pick up right where you left off.",
  MEDIA_ERR_ABORTED: "The media didn't finish loading. Please try playing it again.",
  MEDIA_ERR_NETWORK: "The media couldn't load due to a network issue. Please check your connection and try again.",
  MEDIA_ERR_DECODE: 'The media file appears to be corrupted or in an unsupported format.',
  MEDIA_ERR_SRC_NOT_SUPPORTED: "The media can't play because the format isn't supported by your browser."
} as const);